module.exports = __webpack_public_path__ + "img/heatmap-light-01.0b4ec033.jpg";